<template>
	<div class="set_face">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置人脸识别阈值</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据需求设置人脸识别阈值，值越大识别越严格，建议使用默认值（不设置即可）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceSetFaceThreshold(int nThreshold);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">nThreshold：阈值，范围50-100, int类型</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">bool类型，true表示成功，false表示失败</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool bRet = SKFaceSetFaceThreshold(80);</code></pre>
		<pre class="doc_main_pre"><code class="doc_main_code">// SDK使用示例代码
//SDK初始化回调函数,用于获取SDK鉴权状态
void __stdcall SDKInitCallBack(int nCode, const char* pszMsg)
{
    g_nSDKInitCode = nCode;
    printf("SDK Init::code = %d, msg = %s\n", nCode, pszMsg);
}
	
//1. SDK初始化
string strAPIKey = "xxxxxx";
string strAPISecret = "xxxxxx";
bool bSDKInitFlag = SKFaceInitSDK(strAPIKey.c_str(), strAPISecret.c_str(), SDKInitCallBack);
//2. 视频人脸检测与跟踪初始化
int nCameraWidth = 1920;    
int nCameraHeight = 1080;       
bool bVideoTrackInitFlag = SKFaceVideoTrackInit(nCameraWidth,nCameraHeight,1,false);
//3. 在视频帧中调用视频检测检测与跟踪，需要SDK初始化成功且SDK初始化回调函数状态码code=0时才可以使用
int nFaceNum = 0;
CFaceStruct **pFacesList = SKFaceVideoTrack((unsigned char*)pBGR24Data,nFaceNum);
for(int nFaceIndex = 0; nFaceIndex < nFaceNum; nFaceIndex++)
{
CFaceStruct *pFace = pFacesList[nFaceIndex];
    // 处理人脸数据
}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','基础接口','设置人脸识别阈值'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.set_face{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/basics/setFace.vue